export type ChallengeAdminSort =
    | 'CREATED_AT_DESC'
    | 'CREATED_AT_ASC'
    | 'MONEY_TO_WIN_DESC'
    | 'MONEY_TO_WIN_ASC'
    | 'STATE_ASC'
    | 'STATE_DESC';

export interface ChallengeAdminListItemDto {
    id: number;
    createdAt: string | null;
    state: number;
    moneyAccept: number;
    enterFee: number;
    moneyToWin: number;
    isPrivate: boolean;
    matchId: number | null;
    homeTeamName: string | null;
    awayTeamName: string | null;
    matchStartDate: string | null;
    creatorUserId: number | null;
    creatorName: string | null;
    participantCount: number;
    participantNames: string | null;
}

export interface ChallengeAdminMatchDto {
    matchId: number;
    homeTeamName: string | null;
    awayTeamName: string | null;
    startDate: string | null;
    matchState: number | null;
    scoreHome: number | null;
    scoreAway: number | null;
}

export interface ChallengeAdminParticipantDto {
    id: number;
    userId: number;
    userName: string | null;
    userPhotoUrl: string | null;
    isCreator: boolean;
    state: number;
    moneyReturned: number;
    finalCoefficient: number;
    placedBetId: number | null;
    placedBetCoefficient: number | null;
    placedBetState: number | null;
    betLabel: string | null;
    varietyName: string | null;
    betGroupName: string | null;
    betTypeName: string | null;
}

export interface ChallengeAdminDetailDto {
    id: number;
    createdAt: string | null;
    state: number;
    moneyAccept: number;
    enterFee: number;
    moneyToWin: number;
    isPrivate: boolean;
    maxParticipants: number;
    version: number;
    match: ChallengeAdminMatchDto | null;
    participants: ChallengeAdminParticipantDto[];
}

export interface PaginatedChallengesResponseDto {
    items: ChallengeAdminListItemDto[];
    offset: number;
    limit: number;
    totalItems: number;
}

export interface UpdateChallengeAdminRequest {
    state?: number;
    moneyAccept?: number;
    enterFee?: number;
    moneyToWin?: number;
    isPrivate?: boolean;
}

export interface UpdateChallengeParticipantAdminRequest {
    state?: number;
    moneyReturned?: number;
    finalCoefficient?: number;
    adjustBalance?: boolean;
}

export const CHALLENGE_STATE_OPTIONS: { value: number; label: string }[] = [
    { value: 1, label: 'Pending' },
    { value: 2, label: 'Accepted' },
    { value: 3, label: 'Rejected' },
    { value: 4, label: 'Started' },
    { value: 5, label: 'Finished' },
    { value: 6, label: 'Canceled' },
];

export const PARTICIPANT_STATE_OPTIONS: { value: number; label: string }[] = [
    { value: 1, label: 'Pending' },
    { value: 2, label: 'Accepted' },
    { value: 3, label: 'Rejected' },
    { value: 4, label: 'Won' },
    { value: 5, label: 'Lost' },
    { value: 6, label: 'Draw' },
    { value: 7, label: 'Return' },
];

export const challengeStateLabel = (state: number): string =>
    CHALLENGE_STATE_OPTIONS.find(o => o.value === state)?.label ?? String(state);

export const participantStateLabel = (state: number): string =>
    PARTICIPANT_STATE_OPTIONS.find(o => o.value === state)?.label ?? String(state);
